import React from "react";
import pageStyles from "../styles/PageLayout.module.css";
import PageHeader from "../shared/PageHeader";
import PageContent from "../shared/PageContent";
import TemplatesSection from "../sections/TemplatesSection";

export function TemplatesPage({ templates }) {
  return (
    <div className={pageStyles.page}>
      <PageHeader
        title="Шаблоны"
        description="Настраивайте промпты, порядок карточек, размер страницы и состояние активности."
      />
      <PageContent>
        <TemplatesSection mode="page" state={templates.state} actions={templates.actions} />
      </PageContent>
    </div>
  );
}

export default TemplatesPage;
